import { render, staticRenderFns } from "./AvatarEdition.vue?vue&type=template&id=206a71a6&scoped=true"
import script from "./AvatarEdition.vue?vue&type=script&lang=js"
export * from "./AvatarEdition.vue?vue&type=script&lang=js"
import style0 from "./AvatarEdition.vue?vue&type=style&index=0&id=206a71a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a71a6",
  null
  
)

export default component.exports